export const ROUTES = {
  HOME: "/",
  FORETAGSLAN: "/foretagslan",
  FAKTURKOP: "/fakturakop",
  ONBOARDING: "/onboarding",
  FAKTURAKOP_ONBOARDING: "/fakturakop/onboarding",
  INKASSO_ONBOARDING: "/inkasso/onboarding",
  inkasso: "/inkasso",
  ABOUTUS: "aboutus",
  BLOG: "/blog",
  FAQS: "/faq",
  VART_ANSVAR: "/vart-ansvar"
};
